<template>
    <div class="bottom-buy-card">
        <div class="links-wrap">
            <h6 class="grey-text-small mb-2 text-500">{{localizeList.clickBookAccept}}:</h6>

            <div class="align-center">
                <a v-if="termsTariffs && termsTariffs.length && hasAviaFlight"
                   :href="termsTariffs"
                   target="_blank">
                    {{localizeList.termsTariffs}}
                </a>

                <icon v-if="termsTariffs && termsTariffs.length && hasAviaFlight"
                      name="angle" width="15px" height="15px" fill="#bbb"
                      class="ml-3 mr-3"
                      style="transform: rotate(-90deg)"/>

                <a v-if="submittingAgreePrivacyPolicy && submittingAgreePrivacyPolicy.length"
                   :href="submittingAgreePrivacyPolicy"
                   target="_blank">
                    {{localizeList.submittingAgreePrivacyPolicy}}
                </a>

                <icon v-if="submittingAgreePrivacyPolicy && submittingAgreePrivacyPolicy.length"
                      name="angle" width="15px" height="15px" fill="#bbb"
                      class="ml-3 mr-3"
                      style="transform: rotate(-90deg)"/>

                <a v-if="offerLink && offerLink.length"
                   :href="offerLink"
                   target="_blank">
                    {{localizeList.offerAgreement}}
                </a>

                <icon v-if="offerLink && offerLink.length && (tourBooking && tourBooking.length || hasTourImage)"
                      name="angle" width="15px" height="15px" fill="#bbb"
                      class="ml-3 mr-3"
                      style="transform: rotate(-90deg)"/>

                <p v-if="tourBooking && tourBooking.length || hasTourImage"
                   @click="rightModalBooking()"
                   class="booking-info">{{ localizeList.tourBookingConditions }}</p>
            </div>

            <h6 class="grey-text-small mt-3 text-500">{{localizeList.giveConsentSpecifiedPersonsForProcessingPersonalData}}</h6>
        </div>
        <div class="price-wrap">
            <div class="price-text align-center justify-between mb-4">
                <h4 class="total-to-pay">{{localizeList.totalToPay}}:</h4>
                <h3 class="price">{{correctPrice(cardData.totalPrice)}} {{getCurrencyDisplayBySettings(cardData.tourCurrency)}}</h3>
            </div>

            <div class="price-item">
                <base-button @click="toggleCard()"
                      background="var(--orange-color)"
                      padding="7px"> 
                     <icon name="basket" width="23px" height="23px" fill="var(--white-color)"/>
                </base-button>
                <base-button
                        @click="buyTour()"
                        background="var(--orange-color)"
                        padding="9px 24px"
                        class="booking-btn">{{localizeList.registerBooking}}</base-button>

                <div v-if="getWindowSettings.showQuiQuoService && getQuiQuoJSON()" class="qq-btn-place qui-quo-item" :data-value="getQuiQuoJSON()">
                </div>
            </div>
        </div>

        <div v-if="cardLoaderStatus" class="card-loader-wrap">
            <base-loader size="50" weight="3"/>
        </div>
    </div>
</template>

<script>
    export default {
        name: "bottom-buy-card",
        props: {
            cardData: {
                type: Object,
                default: () => {}
            },
            tour: {
                type: Object,
                default: () => {}
            },
            tourHeadline: {
                type: Object,
                default: () => {}
            },
            residence: {
                type: Array,
                default: () => []
            },
            tourBooking: {
                type: String,
                default: ''
            },
            offerLink: {
                type: String,
                default: ''
            },
            termsTariffs: {
                type: String,
                default: ''
            },
            submittingAgreePrivacyPolicy: {
                type: String,
                default: ''
            },
            cardLoaderStatus: {
                type: Boolean,
                default: false
            },
            hasTourImage: {
                type: Boolean,
                default: false
            },

        },
        computed: {
            hasAviaFlight() {
                return this.cardData.serviceTourists
                        .map(x => x.ServiceType)
                        .includes(1)
            },
            getWindowSettings(){
                return window.settings
            },
        },
        methods: {
            getQuiQuoJSON(){
                const getTourDataQuiQuo = window.settings.getTourDataQuiQuo;
                const { adult, childs, childAges } = this.getAdultAndChildsFromHref()
                const serviceTourCardData = this.cardData.serviceTourists.find(el => el.type === 'residence')
                const [residence] = this.residence
                if(!serviceTourCardData || !this.tour || !residence) return;
                
                const serviceTour = this.tour.Services.find(el => el.SvKey === 3)
                const foodHeader = residence.selectedFood || residence.foodHeaderAll[0]

                const hotelUrl = serviceTour.Http;
                const tourUrl = this.tour.TourUrl;
                const tourName = this.tour.Name;

                const name = getTourDataQuiQuo ? tourName : serviceTour.Hotel.Value;
                const href = getTourDataQuiQuo ? tourUrl : hotelUrl

                const startDate = this.tour.StartDate.split('T')[0];
                const [year, month, day] = startDate.split('-') 
                const beginDate = `${day}.${month}.${year}`

                const imageUrl = this.residence[0]?.hotelImages[0];
                const cityAndResortString = residence.hotelResort ? `${residence.hotelCity}, ${residence.hotelResort}` : residence.hotelCity

                const QuiQuoObject = {
                    checkinDt: beginDate,
                    nights: String(this.tour.DurationInNight),
                    hotelName: name,
                    roomType: serviceTourCardData.Name,  
                    boardType: foodHeader,
                    price: this.cardData.totalPrice,
                    currency: this.cardData.tourCurrency?.IsoCode || this.getCurrencyFromHref(),
                    city_from: this.tourHeadline.from,
                    occupancy: {
                    adultsCount: parseInt(adult),
                    childrenCount: childs || 0,
                    childAges: childAges || 0,
                    },
                    region: residence.hotelCity,
                    country: cityAndResortString,
                    thumbnail: imageUrl || "",
                    href
                }

                return JSON.stringify(QuiQuoObject)
            },
            getCurrencyFromHref(){
                let currency;
                location.href.split('&').forEach(x => {
                    if (x.includes('currency')) {
                    currency = x.split('=')[1]
                    }
                });
                return currency
            },
            getAdultAndChildsFromHref(){
                let adult = null;
                let childs = null;
                let childAges = null;

                location.href.split('&').forEach(x => {
                    if (x.includes('adultCount')) {
                    adult = x.split('=')[1]
                    }
                    if (x.includes('childAges')) {
                    childAges = x.split('=')[1]
                    }
                    if (x.includes('childAges')) {
                    childs = x.split('=')[1].split(',').length
                    }
                });

                return {
                    adult,
                    childs,
                    childAges
                }
            },
            correctPrice(val, round = false) {
                if (round) {
                    val = Math.round(val);
                }
                const isFloat = val % 1 !== 0;
                let res = new Intl.NumberFormat().format(val);

                if (res.includes(".") || !isFloat) {
                    res = res.replace(/,/g, " ");
                } else {
                    res = res.replace(/,/g, ".");
                }
                res = (res.includes("NaN") || isNaN(parseInt(res))) ? "" : res;
                return res
            },
            getCurrencyDisplayBySettings(rate){
                if (!rate) return "";

                return this.$store.getters['getCurrencyDisplayBySettings'](rate);
            },
            rightModalBooking() {
                this.$emit('rightModalBooking')
            },
            buyTour() {
                this.$emit('buyTour')
            },
            toggleCard() {
                const basketNavCardWrap = document.querySelector('.basket-nav-card-wrap');
                basketNavCardWrap.style.transition = "0.2s all";

                this.$emit('toggleCard')
            }
        }
    }
</script>

<style scoped>

    .bottom-buy-card {
        position: relative;
        padding: 12px;
        background: var(--white-color);
        box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.11);
        border-radius: 4px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .links-wrap p,
    .links-wrap a {
        font-size: 14px;
        line-height: 20px;
        color: var(--primary-color);
        cursor: pointer;
        display: block;
        text-decoration: underline;
    }

    .price-wrap {
        flex: 1 0 auto;
        min-width: 260px;
    }

    .price-text {
        margin-left: 49px;
        gap: 10px;
    }

    .price-item {
        display: flex;
        align-items: center;
        gap: 10px;
    }

    .booking-btn {
        flex-grow: 1;
    }

    .qui-quo-item {
        margin-bottom: 4px;
    }

    .price {
        font-size: 24px;
        line-height: 28px;
    }

    .total-to-pay {
        max-width: 130px;
    }

    .basket .card-loader-wrap {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 2;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: rgba(200, 200, 200, .5);
    }

</style>
